import { EnterpriseSearchService, ServiceType } from '@sabstravtech/obtservices/angular';
import { RailEnterpriseSearchInterface } from '@sabstravtech/obtservices/base';
import { Component, Input } from '@angular/core';

import { ProductLoadingScreen } from './product-loading-screen';

@Component({
  selector: 'app-express-loading-screen',
  templateUrl: './rail-loading-screen.component.html',
  styleUrls: [],
  standalone: false
})
export class ExpressLoadingScreenComponent extends ProductLoadingScreen<RailEnterpriseSearchInterface> {
  @Input() animated = true;
  constructor(service: EnterpriseSearchService) {
    super(service, service.searches[ServiceType.Rail]);
  }
}
